var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8 14H3.6v-1.6h5.2a2.8 2.8 0 11-2.622 3.784l1.498-.563A1.2 1.2 0 108.8 14zM4.4 9.198h10.8a2.8 2.8 0 11-2.622 3.784l1.499-.562a1.2 1.2 0 101.124-1.622H4.4a2.4 2.4 0 010-4.8h6.8a1.2 1.2 0 10-1.125-1.622l-1.498-.562a2.801 2.801 0 114.603 2.964 2.8 2.8 0 01-1.98.82H4.4a.8.8 0 100 1.6z"
  })));
}
export default SvgBreathingIcon;